import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.css';
import App from './App';
import * as Sentry from '@sentry/browser';
import initSentry, {sentryTest} from '@blocksure/blocksure-core/dist/src/utilities/initSentry';
import {checkEnv} from '@blocksure/blocksure-core/dist/src/utilities';

import 'font-awesome/css/font-awesome.css';
import './global.css';
import './icons.css';

global.embedded = window.location !== window.parent.location;

if (global.embedded) {
    document.body.style.backgroundColor = 'transparent';
}

global.Sentry = Sentry;
global.sentryTest = sentryTest;

// Disables sentry for localhost
if (window.location.hostname !== 'localhost') {
    const env = checkEnv();
    initSentry(Sentry, env, 'https://429a14a887094f098b0af28f454d4b20@o102724.ingest.sentry.io/5210844');
    console.info('Current SureApp env', env);
}

ReactDOM.render(<App surelyncProps={null}/>, document.getElementById('root'));
